import { createAction } from '@reduxjs/toolkit';

const SET_IS_COMING_FROM_LOADING_SCREEN = 'SET_IS_COMING_FROM_LOADING_SCREEN';
export const setIsComingfromLoadingScreen = createAction<boolean>(
  SET_IS_COMING_FROM_LOADING_SCREEN,
);
